// import css
import './theme/index.less'
import ZkLoginLog from './baseComponents/loginLog'
import ZkOperatorLog from './baseComponents/operatorLog'
import ZkDictionaryTransform from './baseComponents/dictionaryTransform'
import ZkTreeGrid from './baseComponents/treeGrid'
import ZkResource from './baseComponents/resource'
import ZkOperateBar from './baseComponents/operateBar'
import ZkToolBar from './baseComponents/toolBar'
import ZkTable from './baseComponents/table'

import resourceTree from './baseComponents/resourceTree'
import ZkAddOrUpdateResource from './baseComponents/addOrUpdateResource'
import ZkkvItem from './baseComponents/kvItem'
import ZkDictionaryValue from './baseComponents/dictionValue'
import ZkDictionarySelect from './baseComponents/dictionarySelect'

import ZKRoleGroup from './baseComponents/roleGroup'
import ZKRoleUser from './baseComponents/roleUser'
import ZkRoleLayout from './baseComponents/roleLayout'

import ZkSystemDictionary from './baseComponents/systemDictionary'
import ZkSysDictSaveOrUpdate from './baseComponents/systemDictSaveOrUpdate'
import ZkSystemAnnouncement from './baseComponents/systemAnnouncement'
import ZkSystemOptSaveOrUpdate from './baseComponents/systemOptSaveOrUpdate'
import ZkUserTransfer from './baseComponents/userTransfer'
import ZkButtonGroup from './baseComponents/buttonGroup'

import ZkUserManager from './baseComponents/userManage'
import ZkUserDetail from './baseComponents/userDetail'
import ZkUserSaveOrUpdate from './baseComponents/userSaveOrUpdate'
import ZkUserAllotRole from './baseComponents/userAllotRole'
import ZkAuthTree from './baseComponents/authTree'
import ZkDepartment from './baseComponents/department'
import ZkDepartmentSaveOrUpdate from './baseComponents/departmentSaveOrUpdate'
import ZKArea from './baseComponents/area'
import ZkAreaSaveOrUpdate from './baseComponents/areaSaveOrUpdate'
import ZkLangChange from './baseComponents/langChange'
import ZkUserInfo from './baseComponents/loginUserInfo'
import ZkModifyPwd from './baseComponents/modifyPwd'
import ZkErrorPage from './baseComponents/error'
import ZkEmailAndPhone from './baseComponents/emailAndPhone'
import ZkSvgIcon from './baseComponents/svg'
import ZkDSTSaveOrUpdate from './baseComponents/dstSaveOrUpdate'
import ZkKvLine from './baseComponents/kvLine'

import ZkMessageAnnSaveOrUpdate from './baseComponents/messageAnnSaveOrUpdate'

// service 基础服务接口
import * as area from './services/area.js'
import * as auth from './services/auth.js'
import * as dictionary from './services/dictionary.js'
import * as loginLog from './services/loginLog.js'
import * as operateLog from './services/operateLog.js'
import * as options from './services/options.js'
import * as organization from './services/organization.js'
import * as resource from './services/resource.js'
import * as role from './services/role.js'
import * as user from './services/user.js'

import Mixins from './mixins/index.js'
// import i18
// iresource8
import i18n from './i18n/index.js'

// import http 请求插件封装
import fetch from './plugin/fetch/index.js'

// import utils 常用工具类
import * as utils from './utils/index.js'

const components = [
  ZkKvLine,
  ZkSvgIcon,
  ZkEmailAndPhone,
  ZkTable,
  ZkOperateBar,
  ZkToolBar,
  ZkkvItem,
  ZkDictionaryValue,
  ZkLoginLog,
  ZkOperatorLog,
  ZkUserManager,
  ZkUserAllotRole,
  ZkUserDetail,
  ZkUserSaveOrUpdate,
  ZkDictionaryTransform,
  ZkTreeGrid,
  ZkResource,
  ZkAddOrUpdateResource,
  resourceTree,
  ZkDictionarySelect,
  ZkRoleLayout,
  ZKRoleGroup,
  ZKRoleUser,
  ZkSystemDictionary,
  ZkSysDictSaveOrUpdate,
  ZkSystemOptSaveOrUpdate,
  ZkSystemAnnouncement,
  ZkUserTransfer,
  ZkButtonGroup,
  ZkAuthTree,
  ZkDepartment,
  ZkUserInfo,
  ZkModifyPwd,
  ZkDepartmentSaveOrUpdate,
  ZKArea,
  ZkAreaSaveOrUpdate,
  ZkLangChange,
  ZkErrorPage,
  ZkMessageAnnSaveOrUpdate,
  ZkDSTSaveOrUpdate
]

const install = function(Vue) {
  if (install.installed) return
  components.map(component => Vue.component(component.name, component))
  Vue.use(fetch)
  Vue.use(Mixins)
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export {
  ZkKvLine,
  ZkSvgIcon,
  ZkEmailAndPhone,
  utils,
  fetch,
  i18n,
  ZkkvItem,
  ZkDictionaryValue,
  ZkLoginLog,
  ZkOperatorLog,
  ZkUserManager,
  ZkUserAllotRole,
  ZkUserDetail,
  ZkUserSaveOrUpdate,
  ZkDictionaryTransform,
  ZkTreeGrid,
  ZkOperateBar,
  ZkToolBar,
  ZkResource,
  ZkTable,
  resourceTree,
  ZkAddOrUpdateResource,
  ZkDictionarySelect,
  ZkRoleLayout,
  ZKRoleGroup,
  ZKRoleUser,
  ZkSystemDictionary,
  ZkSysDictSaveOrUpdate,
  ZkSystemAnnouncement,
  ZkSystemOptSaveOrUpdate,
  ZkUserTransfer,
  ZkButtonGroup,
  ZkAuthTree,
  ZkDepartment,
  ZkLangChange,
  ZkUserInfo,
  ZkModifyPwd,
  ZkDepartmentSaveOrUpdate,
  ZKArea,
  ZkAreaSaveOrUpdate,
  ZkErrorPage,
  area,
  auth,
  dictionary,
  loginLog,
  operateLog,
  options,
  organization,
  resource,
  role,
  user,
  ZkMessageAnnSaveOrUpdate,
  ZkDSTSaveOrUpdate
}

export default {
  install
}



// WEBPACK FOOTER //
// ./src/cdpBase/index.js